import Dictionary from '../dictionary';
import DictionaryFactory from '../dictionary-factory';
import OrganizationServer from "@/api/organization";

export const DICTIONARY_FACTORY_ORG_DEPARTMENT = 'org_department';
export const DICTIONARY_FACTORY_ORG_DEPARTMENT_TYPE_VALID = 'VALID';
export const DICTIONARY_FACTORY_ORG_DEPARTMENT_TYPE_ALL = 'ALL';
export default class OrgDepartmentDictionaryFactory extends DictionaryFactory {
    constructor() {
        super({name: DICTIONARY_FACTORY_ORG_DEPARTMENT});
    }

    async getDictionary({type}) {
        let dictionary;
        switch (type) {
            case DICTIONARY_FACTORY_ORG_DEPARTMENT_TYPE_VALID: {
                let departments = [];
                let response = await OrganizationServer.department.list({eq_status: '1'});
                if (response.data.code === '200') {
                    departments = response.data.data;
                }
                dictionary = new Dictionary({items: departments, valueKey: 'id', textKey: 'name'});
                break;
            }
            case DICTIONARY_FACTORY_ORG_DEPARTMENT_TYPE_ALL: {
                let departments = [];
                let response = await OrganizationServer.department.list({});
                if (response.data.code === '200') {
                    departments = response.data.data;
                }
                dictionary = new Dictionary({items: departments, valueKey: 'id', textKey: 'name'});
                break;
            }
        }
        if (dictionary == null) {
            dictionary = new Dictionary({items: []});
        }
        return dictionary;
    }
}